module.exports = __webpack_public_path__ + "img/5.c0b93f8c.png";